/**
 * Fallback spacer until `StorefrontLayout` measures the real fixed header (ResizeObserver).
 * Must stay roughly in sync with typical header height to avoid layout jump before measure.
 */
export const STOREFRONT_HEADER_SPACER_FALLBACK_CLASS = 'h-[132px] sm:h-[120px] lg:h-[128px]';

/** Sticky bars use the live CSS variable `--storefront-header-h` set by `StorefrontLayout`. */
export const STOREFRONT_STICKY_TOP_STYLE = { top: 'var(--storefront-header-h)' as const };
